import { useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswers } from '@fukuri-admins/apis/client/gen/endpoints';

export const useGetStressAssessmentAnswers = (
  threeLetterCode: string,
  stressAssessmentId: number,
  userId: number,
  options?: Parameters<
    typeof useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswers
  >[3]
) => {
  return useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdUsersUserIdAnswers(
    threeLetterCode,
    stressAssessmentId,
    userId,
    options
  );
};
